/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { RescheduleConflictDto } from './reschedule-conflict-dto';
 /**
 *
 *
 * @export
 * @interface SessionRescheduleReferencesDto
 */
export interface SessionRescheduleReferencesDto {

    /**
     * The session being moved
     *
     * @type {JoinEntityDto}
     * @memberof SessionRescheduleReferencesDto
     */
    event: JoinEntityDto;

    /**
     * Proposed start
     *
     * @type {string}
     * @memberof SessionRescheduleReferencesDto
     */
    start: string;

    /**
     * Proposed end, derived from the duration the session already has
     *
     * @type {string}
     * @memberof SessionRescheduleReferencesDto
     */
    end: string;

    /**
     * Whether the move would be accepted. False when any of the flags below is true, or when there is at least one conflict.
     *
     * @type {boolean}
     * @memberof SessionRescheduleReferencesDto
     */
    allowed: boolean;

    /**
     * Whether this session can be moved at all: only a pending one (SCHEDULED or DELAYED) can. A performed, missed or skipped session is history.
     *
     * @type {boolean}
     * @memberof SessionRescheduleReferencesDto
     */
    movable: boolean;

    /**
     * Whether the proposed instant has already passed
     *
     * @type {boolean}
     * @memberof SessionRescheduleReferencesDto
     */
    inPast: boolean;

    /**
     * Whether the proposed slot falls outside the therapy's own date window
     *
     * @type {boolean}
     * @memberof SessionRescheduleReferencesDto
     */
    outOfWindow: boolean;

    /**
     * Sessions of this member that the proposed slot overlaps
     *
     * @type {Array<RescheduleConflictDto>}
     * @memberof SessionRescheduleReferencesDto
     */
    conflicts: Array<RescheduleConflictDto>;
}
